import React, { FunctionComponent, useContext, useState } from "react";
import {
    ButtonRenderProps,
    ButtonProps,
    CommandBarButton,
    ContentSection,
    Stack,
    LabeledText,
    Aside,
    TooltipHost
} from "sprint-common-web";

import { MovieContentSubtype } from "../../../../common/types/MovieContentSubtype";
import { MovieContext } from "../context/MovieContext";
import { EditMovieInfoForm } from "./edit-movie-form/EditMovieInfoForm";

interface MovieInfoProps {
    contentType: MovieContentSubtype;
}

export const MovieInfo: FunctionComponent<MovieInfoProps> = (props: MovieInfoProps) => {
    const { contentType } = props;

    const [isEditAsideOpen, setIsEditAsideOpen] = useState<boolean>(false);
    const movieContext = useContext(MovieContext);

    const openEditAside = () => {
        setIsEditAsideOpen(true);
    };

    const closeEditAside = () => {
        setIsEditAsideOpen(false);
    };

    const isMovieAssociatedToBuzz = !!movieContext.movie.buzz;

    const editButtonProps: ButtonRenderProps<ButtonProps> = {
        render: () => (
            <TooltipHost
                styles={{ root: { display: "flex" } }}
                content={isMovieAssociatedToBuzz ? "Movie is associated to buzz" : ""}
            >
                <CommandBarButton
                    testId="edit-movie-details-button"
                    onClick={openEditAside}
                    text="Edit"
                    icon="EditSolid12"
                    disabled={isMovieAssociatedToBuzz}
                />
            </TooltipHost>
        )
    };

    return (
        <ContentSection isLoading={movieContext.isLoading} header="Info" buttons={[editButtonProps]}>
            <Stack horizontal={true} tokens={{ childrenGap: "100" }}>
                <LabeledText value={movieContext.movie?.title ?? ""} label="Title" />
                <LabeledText value={movieContext.movie?.year ?? ""} label="Year" />
            </Stack>
            <Aside type="form" headerText="Edit Details" isOpen={isEditAsideOpen} onDismiss={closeEditAside}>
                <EditMovieInfoForm contentType={contentType} onSubmited={closeEditAside} onCancel={closeEditAside} />
            </Aside>
        </ContentSection>
    );
};
